import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";
import System from "./System";
import ProtectionScope from "./ProtectionScope";
import AlarmTransmission from "./AlarmTransmission";
import Dates from "./Dates";

const SystemDataTab: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    return <>
        <SettingsCol >
            <SettingsLabel text={"[SID_MNU_TAB_INFO_SCR]"} labelPosition={'floating'} lines={'none'} />
            <System systemId={systemId} />
        </SettingsCol>
        <SettingsCol >
            <SettingsLabel text={"[REACT_DEGREE_OF_PROTECTION]"} labelPosition={'floating'} lines={'none'} />
            <ProtectionScope systemId={systemId} />
        </SettingsCol>
        <SettingsCol >
            <SettingsLabel text={"[REACT_ALARM_TRANSMISSION]"} labelPosition={'floating'} lines={'none'} />
            <AlarmTransmission systemId={systemId} />
            <SettingsLabel text={"[REACT_DATES]"} labelPosition={'floating'} lines={'none'} />
            <Dates systemId={systemId} />
        </SettingsCol>
    </>;
};

export default SystemDataTab;
